/* eslint-disable no-console */


import $inoe from "@/config";
import { register } from 'register-service-worker';

const SW_TRACE = "[ANMOBI][SW-REGISTER]";
const traceSw = (step: string, data?: any) => {
  const stamp = new Date().toISOString();
  if (typeof data === "undefined") {
    console.log(`${SW_TRACE}[${stamp}] ${step}`);
    return;
  }
  console.log(`${SW_TRACE}[${stamp}] ${step}`, data);
};
const traceSwError = (step: string, data?: any) => {
  const stamp = new Date().toISOString();
  if (typeof data === "undefined") {
    console.error(`${SW_TRACE}[${stamp}] ${step}`);
    return;
  }
  console.error(`${SW_TRACE}[${stamp}] ${step}`, data);
};

if (process.env.NODE_ENV === 'production')
 {
  traceSw("register:start", {
    baseUrl: process.env.BASE_URL,
    swUrl: `${process.env.BASE_URL}sw.js`,
    isPilote: $inoe.isPilote(),
    href: window.location.href,
    online: navigator.onLine
  });
  register(`${process.env.BASE_URL}sw.js`, {

    ready() {
      traceSw('ready', {
        controller: !!navigator.serviceWorker.controller,
        scope: navigator.serviceWorker.controller && navigator.serviceWorker.controller.scriptURL
      });
    },
    registered() {
      traceSw('registered');
    },
    cached() {
      traceSw('cached');
    },
    updatefound() {
      traceSw('updatefound');
      document.dispatchEvent(
        new CustomEvent('swDownload')
      );
    },
    updated(registration) {
      traceSw('updated', {
        waiting: !!(registration && registration.waiting),
        installing: !!(registration && registration.installing),
        active: !!(registration && registration.active),
        version: $inoe.getVersionAppMobi()
      });
      
      document.dispatchEvent(
        new CustomEvent('swUpdated', { detail: {registration:registration, version:$inoe.getVersionAppMobi()} })
      )
      
    },
    offline() {
      traceSw('offline');
    },
    error(error) {
      traceSwError('error', error)
    }
  })
}
window.addEventListener('beforeinstallprompt', (event: any) => {


  event.preventDefault();
  var installBtn: any = document.querySelector('#installBtn');
   installBtn.removeAttribute('hidden');

  installBtn.addEventListener('click', () => {
    event.prompt();
    installBtn.setAttribute('hidden', true);
  });
  
});